import { useMsal } from '@azure/msal-react';
import { useParams } from 'react-router';
import WizardForm from '../../../components/forms/WizardForm';
import { WizardFormProps } from '../../../components/forms/WizardForm/types';
import WizardStep from '../../../components/forms/WizardForm/WizardStep';
import updateAccountProps from './updateAccountProps';
import useHtmlTitle from '../../../components/Utilities/useHtmlTitle';
import useBodyClass from '../../../components/Utilities/useBodyClass';
import { FormStepStatus, FormStepStatusDto } from '../../../api/web-api-client';
import useAccountContext from '../../../authentication/hooks';
import OrganisationDetails from '../organisationDetails';

const updateAccountWizardProps: WizardFormProps = {
    locationOnCompletion: '/',
    lastStepNextButtonTitle: 'Save and close',
    // nextButtonTitle: 'Save and next',
    canSaveDraft: false,
    confirmationOnSubmission: {
        modalTitle: 'Update organisation confirmation',
        modalBodyText: 'Are you sure you want to update this organisation?',
        yesButtonTitle: 'Yes, submit',
        noButtonTitle: 'No, cancel',
    },
};

const statuses: FormStepStatusDto[] = [{ status: FormStepStatus.NotStarted }];

const UpdateAccount = () => {
    const { accounts, instance } = useMsal();
    const { id } = useParams();
    const account = useAccountContext();

    const accountId: number = id !== undefined ? Number(id) : 0;
    useHtmlTitle('Manage organisation | NMI Services portal');
    useBodyClass('wizard');
    return (
        <WizardForm {...updateAccountWizardProps}>
            <WizardStep {...updateAccountProps(accounts, instance, statuses, account, accountId)}>
                <OrganisationDetails />
            </WizardStep>
        </WizardForm>
    );
};

export default UpdateAccount;
